export class Controller {

    /** @ngInject */
    constructor($scope,
                $state,
                Alert,
                SaaspassVpnService,) {
        this.$scope = $scope;
        this.$state = $state;
        this.Alert = Alert;
        this.SaaspassVpnService = SaaspassVpnService;
    }

    $onInit() {
        const companyId = this.companyId = this.$state.params.companyId;
        this.config = {};
        this.config.authType = 'SHA512';
        this.config.cipherType = 'AES-256-CBC';
        this.config.remotePort = '1194';
    }

    clearNewSettings(){
        this.newSettings = angular.copy(this.settings);
    }

    generateOvpnConfig() {
        console.log(this.config);
        this.loading = true;
        this.SaaspassVpnService
            .generateOvpnConfig(this.companyId, this.config)
            .then((data) => {
                var file = new Blob([data], {
                    type: 'application/zip'
                });
                // var file = window.URL.createObjectURL(blob);
                var fileURL = URL.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'OpenVPNConfig.zip';
                document.body.appendChild(a);
                a.click();
            }).finally(() => this.loading = false)
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-vpn/configuration/configuration.controller.js